var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1958_2161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18013 16.5004H0V14.3097H2.1641V12.1026H0.0056909V9.91295H2.16306V7.70473H0.00620826V5.50633H2.16668C2.17186 5.39155 2.17962 5.30107 2.17962 5.21059C2.18065 4.23083 2.17444 3.25106 2.18169 2.2713C2.19048 1.13798 2.88374 0.266269 3.95156 0.0444643C4.1347 0.00620432 4.32716 0.00155108 4.51547 0.00155108C9.93373 0 15.352 0 20.7702 0C21.5711 0 21.9995 0.424479 21.9995 1.22173C22.0005 7.73679 22.0005 14.2513 21.9995 20.7664C21.9995 21.5776 21.5732 21.999 20.7547 21.999C15.3453 21.9995 9.9358 22.0005 4.52582 21.999C3.1062 21.999 2.18375 21.0761 2.18013 19.661C2.17755 18.7153 2.18013 17.7702 2.18013 16.8246C2.18013 16.7315 2.18013 16.6379 2.18013 16.5004ZM5.51293 17.5882H18.6569C18.6569 17.1394 18.707 16.6969 18.6465 16.2708C18.5094 15.3061 17.99 14.529 17.3014 13.8651C16.0183 12.6284 14.4606 11.9811 12.6995 11.8559C10.4656 11.6972 8.48462 12.3368 6.85185 13.9023C5.813 14.8986 5.32203 16.1183 5.51293 17.5887V17.5882ZM12.0875 3.30121C10.2778 3.3038 8.78831 4.79077 8.78727 6.59674C8.78624 8.39393 10.2897 9.90054 12.0864 9.90313C13.9039 9.90571 15.397 8.40685 15.3918 6.58433C15.3867 4.76802 13.9081 3.29863 12.0875 3.30121Z",
    fill: "#0057FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51314 17.5877C5.32224 16.1173 5.81269 14.8976 6.85206 13.9013C8.48431 12.3357 10.4658 11.6962 12.6997 11.8549C14.4608 11.98 16.0186 12.6273 17.3016 13.8641C17.9902 14.5279 18.5096 15.305 18.6467 16.2698C18.7072 16.6963 18.6571 17.1384 18.6571 17.5872H5.51314V17.5877Z",
    fill: "#E1EAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0873 3.30121C13.9079 3.29863 15.3865 4.76802 15.3917 6.58433C15.3968 8.40633 13.9037 9.90571 12.0863 9.90312C10.2895 9.90054 8.78659 8.39392 8.78711 6.59674C8.78814 4.79077 10.2771 3.3038 12.0873 3.30121Z",
    fill: "#E1EAFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1958_2161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.91f94ada69d75fb03767e62f552cec5f.svg";
export { ForwardRef as ReactComponent };